





















import Vue from 'vue';
import { mapMutations } from 'vuex';
import { SET_LAYERSELECT_OPEN } from '../../store/types';
export default Vue.extend({
  name: 'LayerSelectToggle',

  methods: {
    ...mapMutations({
      setLayerselectOpen: SET_LAYERSELECT_OPEN
    })
  }
});
